import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => (
    <svg viewBox='0 0 64 64' aria-hidden='true' className={cn('size-8 shrink-0', className)}>
        <rect width='64' height='64' rx='15' fill='#1F5E4D' />
        <path d='M13 41c6-9 11-9 15-3s9 6 13-2 7-10 10-9' fill='none' stroke='#F2B33D' strokeWidth='6' strokeLinecap='round' strokeLinejoin='round' />
        <circle cx='47' cy='19' r='5' fill='#F7F4EC' />
    </svg>
)

interface LogoProps {
    className?: string
    markClassName?: string
    tone?: 'dark' | 'light'
}

export const Logo: FC<LogoProps> = ({ className, markClassName, tone = 'dark' }): ReactNode => (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
        <LogoMark className={markClassName} />
        <span className={cn('font-heading text-xl font-semibold tracking-tight', tone === 'light' ? 'text-white' : 'text-foreground')}>
            {siteConfig.name}
        </span>
    </span>
)
